import {ChangeDetectorRef, Component} from "@angular/core";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {EditService} from "../../../framework/entity/edit/edit-page/edit.service";
import {PricingScheduleData, PricingScheduleFrequency} from "../pricing-schedule.data";

@Component({
    selector: "wbo-pricing-schedule-edit",
    templateUrl: "./pricing-schedule-edit.component.html"
})
export class PricingScheduleEditComponent {
    PricingScheduleFrequency = PricingScheduleFrequency;

    constructor(public model: EntityModel<PricingScheduleData<any>>,
                public editService: EditService,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    startTimeValueChange(): void {
        this.editService.updateValueAndValidity(["firstFinishTime", "frequencyValue"]);
    }

    firstFinishTimeValueChange(): void {
        this.editService.updateValueAndValidity(["startTime", "frequencyValue"]);
    }

    recurringChange(): void {
        this.editService.updateValueAndValidity(["frequencyValue", "finishDate", "finishTime"]);
    }

    frequencyUnitValueChange(): void {
        this.editService.markAsTouched(["frequencyValue"]);
        this.editService.updateValueAndValidity(["frequencyValue"]);
    }
}
